import React from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import { Link } from "react-router"
import 'kendo'

import EquityDMAWidget from './widgets/equity'
import CryptoDMAWidget from './widgets/crypto'
import FutureDMAWidget from './widgets/future'
import FXStreamWidget from './widgets/fxstream'
import PositionWidget from './widgets/position'
import TicketWidget from './widgets/ticket'

export default class WebTopBar extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			widgets: [],

			show_user_menu: false,
		}
	}

	componentDidMount() {
		$('.top_menu').kendoMenu();
		$('.user_menu').kendoMenu();

		window.raiseWidget = (type, args) => {
			this.handleWindow(null, type, args)
		}
	}

	handleWindow(e, type, args) {
		if (e) e.preventDefault()
		let p = document.createElement('div')
		p.id = "widget_" + this.state.widgets.length;
		document.body.appendChild(p)
		args = args || {}
		args.onResize = (w, h) => {
			let opts = {}
			if (w) Object.assign(opts, { width: w })
			if (h) Object.assign(opts, { height: h })
			setTimeout(() => { $(p).data("kendoWindow").setOptions(opts) }, 50)
		}
		switch (type) {
			case 'CryptoCurrency':
				render((<CryptoDMAWidget onTitle={
					(t) => {
						$(p).data("kendoWindow").title(t)
					}
				} {...args} />), p)
				break
			case 'Equity':
				render((<EquityDMAWidget onTitle={
					(t) => {
						$(p).data("kendoWindow").title(t)
					}
				} {...args} />), p)
				break
			case 'Future':
				render((<FutureDMAWidget onTitle={
					(t) => {
						$(p).data("kendoWindow").title(t)
					}
				} {...args} />), p)
				break
			case 'EquityIndexFuture':
				render((<FutureDMAWidget onTitle={
					(t) => {
						$(p).data("kendoWindow").title(t)
					}
				} {...args} />), p)
				break
			case 'FX':
				render((<FXStreamWidget
					onTitle={
						(t) => {
							$(p).data("kendoWindow").title(t)
						}
					} {...args} />), p)
				break
			case 'PositionDetail':
				render((<PositionWidget onTitle={
					(t) => {
						$(p).data("kendoWindow").title(t)
					}
				} {...args} />), p)
				break
			case 'OrderTicket':
				render((<TicketWidget onTitle={
					(t) => {
						$(p).data("kendoWindow").title(t)
					}
				} {...args} />), p)
				break
		}
		this.state.widgets.push(p)

		$(p).kendoWindow({
			width: "703px",
			actions: ["Minimize", "Close"],
			//title: type + " Ticket",
			visible: false,
			animation: { open: { duration: 100 } },
			close: function() {
				unmountComponentAtNode(p)
				$(p).data("kendoWindow").destroy()
			}
		}).data("kendoWindow").center().open()
	}

	render() {
		return (
			<div className={" " + this.state.connectionStatus} style={NavbarStyle}>
				<div className="">
					<ul className="top_menu">
						<li className="">
							Tickets
	            <ul>
								<li className="">
									<a className="k-link" href="#" onClick={(e) => this.handleWindow(e, 'Equity')}>Equity</a>
								</li>
								<li className="">
									<a className="k-link" href="#" onClick={(e) => this.handleWindow(e, 'CryptoCurrency')}>Crypto</a>
								</li>
								<li className="">
									<a className="k-link" href="#" onClick={(e) => this.handleWindow(e, 'Future')}>Future</a>
								</li>
								<li className="">
									<a className="k-link" href="#" onClick={(e) => this.handleWindow(e, 'FX')}>FX</a>
								</li>
								<li className="">
									<a className="k-link" href="#" onClick={(e) => this.handleWindow(e, 'OrderTicket')}>E-Ticket</a>
								</li>
							</ul>
						</li>
						<li className="">
							Monitor
	            <ul>
								<li className="">
									<Link className="k-link" to="ems_monitor">Orders</Link>
								</li>
								<li className="">
									<Link className="k-link" to="pos_monitor">Positions</Link>
								</li>
								<li className="">
									<Link className="k-link" to="pos_search">Search</Link>
								</li>
								<li className="">
									<Link className="k-link" to="instrument_editor">Symbols</Link>
								</li>
							</ul>
						</li>
						<li className="admin">
							Admin
	            <ul>
								<li className="">
									<Link className="k-link" to="admin_services">Services Monitor</Link>
								</li>
								<li className="">
									<Link className="k-link" to="admin_users">Users &amp; Roles</Link>
								</li>
							</ul>
						</li>
					</ul>
					<span id="pageToolbar">
					</span>
					<ul className="user_menu" style={{ right: 0, top: 0, position: 'fixed' }}>
						<li className="">
							{localStorage.username || ''}
							<ul>
								<li className="">
									<Link className="k-link" onClick={
										() => {
											this.setState({ show_user_menu: false }, () => {
												window.location.href = "/logout"
											})
										}
									}>Log out</Link>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>)
	}
}

const NavbarStyle = {
	listStyle: "none",
	position: "fixed",
	top: 0,
	width: "100%",
	zIndex: 1001,
}

const BarMenuItemStyle = {
	padding: "0.2em 1em",
}



// WEBPACK FOOTER //
// ./src/web_topbar.jsx